import * as React from 'react'
import clsx from 'clsx'
import { useDateFieldState } from '@react-stately/datepicker'
import { createCalendar } from '@internationalized/date'
import { useDateField, useDateSegment } from '@react-aria/datepicker'

import { Text } from '@wartek-id/text'

import styles from 'app/KinerjaShared/components/DatePicker/DatePicker.module.css'

import type { AriaDatePickerProps } from '@react-aria/datepicker'
import type { DateValue } from '@internationalized/date'
import type {
  DateFieldState,
  DateSegment as DateSegmentType,
} from '@react-stately/datepicker'

export function DateField(props: AriaDatePickerProps<DateValue>) {
  const state = useDateFieldState({
    ...props,
    locale: 'id-ID',
    createCalendar,
  })

  const ref = React.useRef(null)
  const { fieldProps } = useDateField(props, state as any, ref)

  return (
    <div {...fieldProps} ref={ref} className={clsx(styles.dateField)}>
      {state.segments.map((segment, i) => (
        <DateSegment key={i} segment={segment} state={state} />
      ))}
    </div>
  )
}

function DateSegment({
  segment,
  state,
}: {
  segment: DateSegmentType
  state: DateFieldState
}) {
  const ref = React.useRef(null)
  const { segmentProps } = useDateSegment(segment, state as any, ref)

  // currently we use granularity="date" (default) and it only use year, month, and date
  // in the future, adjust the placeholder to reflect the granularity
  const placeholder = {
    year: 'YYYY',
    month: 'MM',
    day: 'DD',
    hour: 'HH',
    minute: '--',
    second: '--',
    era: '',
    dayPeriod: '',
    literal: '',
    timeZoneName: '',
  }

  return (
    <div
      {...segmentProps}
      ref={ref}
      style={{
        ...segmentProps.style,
      }}
      className={clsx(
        styles.dateFieldSegment,
        segment.isPlaceholder && styles.dateFieldSegmentPlaceholder
      )}
    >
      {/* Always reserve space for the placeholder, to prevent layout shift when editing. */}
      <span
        aria-hidden="true"
        style={{
          display: segment.isPlaceholder ? 'block' : 'none',
          height: segment.isPlaceholder ? '' : 0,
          pointerEvents: 'none',
        }}
      >
        <Text color="inherit">{placeholder[segment.type]}</Text>
      </span>
      {segment.isPlaceholder ? '' : segment.text}
    </div>
  )
}
